// Dashboard mock data

export const dashboardNav = [
  { key: 'overview', label: 'Overview', icon: 'LayoutGrid', to: '/dashboard' },
  { key: 'run', label: 'Run Check', icon: 'Zap', to: '/dashboard/run' },
  { key: 'history', label: 'Check History', icon: 'FileText', to: '/dashboard/history', badge: 7 },
  { key: 'frameworks', label: 'Frameworks', icon: 'BookOpen', to: '/dashboard/frameworks' },
  { key: 'settings', label: 'Settings', icon: 'Settings', to: '/dashboard/settings' },
  { key: 'plan', label: 'My Plan', icon: 'Receipt', to: '/dashboard/plan' },
  { key: 'admin', label: 'Admin', icon: 'Users', to: '/dashboard/admin' },
];

export const dashboardStats = [
  {
    key: 'total',
    label: 'Total Checks',
    value: '7',
    hint: 'Across this session',
    icon: 'ClipboardList',
    tone: 'indigo',
  },
  {
    key: 'last',
    label: 'Last Score',
    value: '88%',
    hint: 'SEC Climate · Infosys',
    icon: 'CircleCheck',
    tone: 'emerald',
  },
  {
    key: 'risk',
    label: 'Last Risk Level',
    value: 'LOW',
    hint: 'Compliant filing',
    icon: 'AlertOctagon',
    tone: 'rose',
  },
  {
    key: 'frameworks',
    label: 'Active Frameworks',
    value: '7',
    hint: 'EU · US · California · Global · UK',
    icon: 'BookMarked',
    tone: 'mint',
  },
];

export const checkHistory = [
  { id: 1, time: '5/9/2026, 1:13:51 AM', file: 'Infosys', framework: 'SEC_CLIMATE', outcome: 'Compliant', score: 88, risk: 'LOW', gaps: 0 },
  { id: 2, time: '5/3/2026, 12:14:12 PM', file: '12', framework: 'CSRD', outcome: 'Compliant', score: 82, risk: 'LOW', gaps: 3 },
  { id: 3, time: '4/28/2026, 1:04:31 PM', file: 'Infosys', framework: 'SEC_CLIMATE', outcome: 'Non-Compliant', score: 63, risk: 'MEDIUM', gaps: 3 },
  { id: 4, time: '4/28/2026, 12:11:58 PM', file: 'TecKube LLC', framework: 'ISSB', outcome: 'Compliant', score: 83, risk: 'LOW', gaps: 3 },
  { id: 5, time: '4/28/2026, 12:08:52 PM', file: 'TecKube LLC', framework: 'CSRD', outcome: 'Compliant', score: 86, risk: 'LOW', gaps: 3 },
  { id: 6, time: '4/28/2026, 12:07:33 PM', file: 'TecKube LLC', framework: 'SEC_CLIMATE', outcome: 'Compliant', score: 100, risk: 'LOW', gaps: 0 },
  { id: 7, time: '4/27/2026, 11:51:12 AM', file: 'Infosys Limited', framework: 'FCA', outcome: 'Non-Compliant', score: 69, risk: 'MEDIUM', gaps: 4 },
];

export const dashboardFrameworks = [
  { code: 'CSRD', name: 'CSRD', region: 'EU', rules: 22, version: 'v1.0' },
  { code: 'SEC', name: 'SEC Climate', region: 'US', rules: 8, version: 'v1.0' },
  { code: 'SB253', name: 'CARB SB253', region: 'California', rules: 6, version: 'v1.0' },
  { code: 'SB261', name: 'CARB SB261', region: 'California', rules: 12, version: 'v1.0' },
  { code: 'ISSB', name: 'ISSB / IFRS', region: 'Global', rules: 18, version: 'v1.0' },
  { code: 'FCA', name: 'UK FCA', region: 'UK', rules: 14, version: 'v1.0' },
  { code: 'SFDR', name: 'SFDR', region: 'EU', rules: 10, version: 'v1.0' },
];

export const sessionUser = {
  name: 'Iowolab',
  email: 'iowolab@gmail.com',
  role: 'superadmin',
  initials: 'IO',
};
